import gsap from 'gsap';
import { Selectors } from 'src/app/data/enum/selectors';
import { VoiceSearchFeature } from './voice-search-page.types';

const remoteControlOutTween = () => {
  return gsap.to(Selectors.REMOTE_WRAPPER, {
    autoAlpha: 0,
    duration: 0.5,
  });
};
const remoteControlInTween = () => {
  return gsap.to([Selectors.REMOTE_WRAPPER, Selectors.DISCLAIMER], {
    autoAlpha: 1,
    duration: 0.5,
  });
};

export const voiceSearchPageAnimations = {
  [VoiceSearchFeature['action-movies']]: {
    introAnimation: (_: HTMLVideoElement, __: boolean, startCallback?: gsap.Callback) => {
      return gsap
        .timeline({ onStart: startCallback })
        .add(remoteControlOutTween(), 0)
        .set('[data-animation="front-door"]', {
          autoAlpha: 0,
        })
        .to(
          '[data-animation="intro-screen-wrapper"]',
          {
            autoAlpha: 0,
            duration: 0.5,
          },
          0,
        );
    },
    outroAnimation: (_: boolean) => {
      return gsap
        .timeline()
        .to(
          '[data-animation="intro-screen-wrapper"]',
          {
            autoAlpha: 1,
            duration: 0.5,
          },
          0,
        )
        .to(
          '.c06-end-screen',
          {
            autoAlpha: 0,
          },
          0,
        )
        .add(remoteControlInTween());
    },
  },
  [VoiceSearchFeature['lights']]: {
    introAnimation: (_: HTMLVideoElement, isLandscape: boolean, startCallback?: gsap.Callback) => {
      return gsap
        .timeline({ onStart: startCallback })
        .add(remoteControlOutTween(), 0)
        .to(
          ['.c01-tv-frame', 'img.hisense-tv-frame'],
          {
            ease: 'power2.out',
            scale: 0.46,
            duration: !isLandscape ? 1 : 2,
          },
          1,
        )
        .to(
          '.voice-search-background',
          {
            ease: 'power2.out',
            scale: 1,
            transformOrigin: '50% 25%',
            duration: !isLandscape ? 1 : 2,
          },
          1,
        )
        .to(
          '.dim-ligths',
          {
            autoAlpha: 0,
          },
          3,
        );
    },
    outroAnimation: (isLandscape: boolean) => {
      return gsap
        .timeline()
        .to(
          '.c06-end-screen',
          {
            autoAlpha: 0,
          },
          0,
        )
        .to(
          ['.c01-tv-frame', 'img.hisense-tv-frame'],
          {
            ease: 'power2.out',
            scale: !isLandscape ? 0.46 : 1,
            duration: 2,
            clearProps: 'transform',
          },
          1,
        )
        .to(
          '.voice-search-background',
          {
            ease: 'power2.out',
            scale: !isLandscape ? 1 : 2.25,
            transformOrigin: '50% 25%',
            duration: 2,
          },
          1,
        )
        .to(
          '.dim-ligths',
          {
            autoAlpha: 1,
          },
          2.25,
        )
        .add(remoteControlInTween(), 2.25);
    },
  },
  [VoiceSearchFeature['children-shows']]: {
    introAnimation: (_: HTMLVideoElement, __: boolean, startCallback?: gsap.Callback) => {
      return gsap
        .timeline({ onStart: startCallback })
        .set('[data-animation="action-movies"]', {
          autoAlpha: 0,
        })
        .add(remoteControlOutTween(), 0)
        .to(
          '[data-animation="intro-screen-wrapper"]',
          {
            autoAlpha: 0,
            duration: 0.5,
          },
          0,
        );
    },
    outroAnimation: () => {
      return gsap
        .timeline()
        .to(
          '[data-animation="intro-screen-wrapper"]',
          {
            autoAlpha: 1,
            duration: 0.5,
          },
          0,
        )
        .to(
          '.c06-end-screen',
          {
            autoAlpha: 0,
          },
          0,
        )
        .add(remoteControlInTween(), 0.5)
        .set('[data-animation="action-movies"]', {
          autoAlpha: 1,
        });
    },
  },
  [VoiceSearchFeature['front-door']]: {
    introAnimation: (video: HTMLVideoElement, _: boolean, startCallback?: gsap.Callback) => {
      return gsap
        .timeline({
          onStart: startCallback,
          onComplete: () => {
            video.play();
          },
        })
        .set(['[data-animation="action-movies"]', '[data-animation="children-shows"]'], {
          autoAlpha: 0,
        })
        .set('[data-animation="front-door"]', {
          autoAlpha: 1,
        })
        .add(remoteControlOutTween(), 0)
        .to(
          '[data-animation="intro-screen-wrapper"]',
          {
            autoAlpha: 0,
            duration: 0.5,
          },
          0,
        );
    },
    outroAnimation: () => {
      return gsap
        .timeline()
        .to(
          '[data-animation="intro-screen-wrapper"]',
          {
            autoAlpha: 1,
            duration: 0.5,
          },
          0,
        )
        .to(
          '.c06-end-screen',
          {
            autoAlpha: 0,
          },
          0,
        )
        .add(remoteControlInTween(), 0.5)
        .set(['[data-animation="action-movies"]', '[data-animation="children-shows"]'], {
          autoAlpha: 1,
        });
    },
  },
};
